import React from "react";
import sanitize from "sanitize-html";
import PropTypes from "prop-types";
import WhyAccountStyles from "@components/FreelancerSelfEmployedIndustryPage/WhyAccountStyles";

const sanitizeSettings = {
  allowedTags: ["p", "ol", "ul", "li", "h2", "img", "strong"],
  allowedAttributes: {
    img: ["src", "alt", "style", "height", "width"],
  },
};
const WhyAccount = ({ data, onCtaClicked, isMobile }) => {
  const { why, businessNeeds, scheduledConsultation } = data;

  return (
    <WhyAccountStyles>
      <div className="why-account">
        <div className="why-container">
          <h2 className="why-title">
            {why.title}
          </h2>
          <div className="why-content">
            <div className="why-text-container">
              <div
                className="subtitle"
                dangerouslySetInnerHTML={{
                  __html: sanitize(why.subtitle, sanitizeSettings),
                }}
              />
            </div>
            <div className="image-wrap">
              <img
                src={why.image.url}
                alt="Money"
                width="500px"
                height="500px"
              />
            </div>
          </div>
        </div>

        <div className="getting-started-cards">
          <div>
            {isMobile && (
              <h2 className="mid-title">
                {businessNeeds.title.slice(0, 17)}
                {"\n"}
                {businessNeeds.title.slice(18, 30)}
                {"\n"}
                {businessNeeds.title.slice(31, 42)}
                {"\n"}
                {businessNeeds.title.slice(43, 58)}
                {"\n"}
                {businessNeeds.title.slice(59, 74)}
                {"\n"}
                {businessNeeds.title.slice(75)}
              </h2>
            )}
            {!isMobile && (
              <h2 className="mid-title">
                {businessNeeds.title.slice(0, 43)}
                {"\n"}
                {businessNeeds.title.slice(43)}
              </h2>
            )}
          </div>
          <div>
            <div className="works-container">
              {businessNeeds.list.map(
                ({ icon, description, title, icon_mobile }, idx) => (
                  <div key={icon.id} className="getting-started-card card">
                    <div className="getting-started-card-body card-body">
                      <div className="image">
                        <img
                          src={icon.url}
                          alt="Icon"
                          width="500px"
                          height="500px"
                        />
                      </div>
                      <div className="text">
                        <h3 className="getting-started-title">{title}</h3>
                        <p className="getting-started-description">
                          {description}
                        </p>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </WhyAccountStyles>
  );
};

WhyAccount.propTypes = {
  data: PropTypes.object.isRequired,
  onCtaClicked: PropTypes.func.isRequired,
};

export default WhyAccount;
